<style lang="less" scoped>
  .checkbox{
    width: 100%;
    padding-top: .1rem;
    align-items: flex-start;
    justify-content: flex-start;
    .checkbox-bg{
      width: .75rem;
      height: .75rem;
      background-color: #fff;
      border-radius: .15rem;
      margin-right: .3rem;
      margin-top: .1rem;
      overflow: hidden;
      #agreement{
        border: 0.05rem solid black;
      }
    }
    input {
      width: .65rem;
      height: .65rem;
      margin: 0.05rem;
    }
    input:checked {
      background-color: #1c1151;
      //-webkit-mask: url('./img/check.svg') no-repeat 50% 50%;
      //mask: url('./img/check.svg') no-repeat 50% 50%;
      -webkit-mask: url('data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8cGF0aCBkPSJNMjMuMzg0IDEwLjMyOWMtOC44NTMgMTIuNDYtOS41MDkgMTIuNzg4LTE1LjQxMSA5LjgzNy0xMC4zMjktNS40MS0xMC40OTMtMi42MjMtMC4xNjQgNS41NzRsNi4zOTQgNS4wODIgMTAuMDAxLTE0LjkyYzEwLjY1Ny0xNS45MDMgMTAuMDAxLTIwLjY1OC0wLjgyLTUuNTc0eiI+PC9wYXRoPgo8L3N2Zz4K') no-repeat 50% 50%;
      mask: url('data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8cGF0aCBkPSJNMjMuMzg0IDEwLjMyOWMtOC44NTMgMTIuNDYtOS41MDkgMTIuNzg4LTE1LjQxMSA5LjgzNy0xMC4zMjktNS40MS0xMC40OTMtMi42MjMtMC4xNjQgNS41NzRsNi4zOTQgNS4wODIgMTAuMDAxLTE0LjkyYzEwLjY1Ny0xNS45MDMgMTAuMDAxLTIwLjY1OC0wLjgyLTUuNTc0eiI+PC9wYXRoPgo8L3N2Zz4K') no-repeat 50% 50%;
      -webkit-mask-size: cover;
      mask-size: cover;
    }

    .desc {
      display: inline-block;
    }
  }

</style>
<template>
  <div class="checkbox flex-box" >
    <div class="checkbox-bg">
      <input type="checkbox" id="agreement" :checked="checked" @change="change">
    </div>
    <div class="desc flex1">
      <label for="agreement">
        <slot name="label"></slot>
      </label>
      <slot></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['checked'],
    methods: {
      change () {
        this.$emit('update:checked', !this.checked)
      }
    }
  }
</script>
